module.exports = __webpack_public_path__ + "static/demo-1-fa55570489411dfa90fa483160766c55.png";